import script from "./QRCodeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./QRCodeInput.vue?vue&type=script&setup=true&lang=js"

import "./QRCodeInput.vue?vue&type=style&index=0&id=0527dfc4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0527dfc4"]])

export default __exports__